import DataProvider from '@/components/buckets/bucket-providers/BucketDataProviderGeneral.js'

export default {
  store: {},
  async searchCases(searchParams) { // casetype.name, bucketId, page, pageSize, searchFields, searchTerm
    const caseType = this.store.state.buckets.current.caseType
    if (caseType === undefined) { return }
    await this.store.dispatch('getOrderedBucket', { bucketId: searchParams.bucketId, page: searchParams.page, pageSize: searchParams.itemsPerPage, sortField: searchParams.sortField, sortDirection: searchParams.sortDirection, searchTerm: searchParams.searchTerm, searchableBy: searchParams.searchableBy })
    const bucket = this.store.state.buckets.current.bucket
    const preferences = this.store.state.currentUser.me.preferences

    const tempDataProvider = Object.assign({}, DataProvider, { store: this.store })
    tempDataProvider.setupData(caseType, bucket, preferences)

    this.store.dispatch("stopBucketLoading")
  }
}
